import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVideoOutlined = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinejoin: "round",
		d: "M2 5.862C2 4.834 2.871 4 3.946 4h4.216c1.075 0 1.946.834 1.946 1.862v5.276c0 1.028-.871 1.862-1.946 1.862H3.946C2.87 13 2 12.166 2 11.138zm8.108 1.397 2.953-1.413c.432-.207.939.093.939.555v4.198c0 .462-.507.762-.939.555l-2.953-1.413z"
	})
});
export default SvgVideoOutlined;
